export const ZOOM_LEVEL = 13;
export const TIMEOUT_SEC = 10;
export const API_URL = "https://geo.ipify.org/api/v2/country,city?apiKey=";
export const API_KEY = "at_vdvZu8FMoPbFD4UMvEtfGtxiCJghI";

("https://geo.ipify.org/api/v2/country,city?apiKey=at_vdvZu8FMoPbFD4UMvEtfGtxiCJghI&ipAddress=8.8.8.8");
